import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/get-started";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const OG_ALT = "Digitally Baffled LTD — UK Digital Transformation Consultancy";
const DESC =
  "Book a free 30-minute discovery call with Digitally Baffled. No obligation, no jargon — just an honest conversation about your digital goals and how we can help.";

const eventJsonLd = {
  "@context": "https://schema.org",
  "@type": "Event",
  "@id": `${SITE_URL}/get-started#event`,
  name: "Free 30-Minute Discovery Call — Digitally Baffled",
  description:
    "A free, no-obligation 30-minute discovery call with Digitally Baffled to discuss your digital transformation goals.",
  url: `${SITE_URL}/get-started`,
  eventAttendanceMode: "https://schema.org/OnlineEventAttendanceMode",
  eventStatus: "https://schema.org/EventScheduled",
  isAccessibleForFree: true,
  organizer: { "@id": `${SITE_URL}/#organization` },
};

export const Route = createFileRoute("/get-started")({
  head: () => ({
    meta: [
      { title: "Get Started | Digitally Baffled" },
      { name: "description", content: DESC },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Get Started — Digitally Baffled" },
      {
        property: "og:description",
        content:
          "Get started with Digitally Baffled. Send us an enquiry or schedule a call — no obligation, no jargon.",
      },
      { property: "og:url", content: `${SITE_URL}/get-started` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: OG_ALT },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Get Started — Digitally Baffled" },
      {
        name: "twitter:description",
        content:
          "Get started with Digitally Baffled. Send us an enquiry or schedule a call — no obligation, no jargon.",
      },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/get-started` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(eventJsonLd) },
    ],
  }),
  component: Page,
});
